import { render, staticRenderFns } from "./View-ajuda.vue?vue&type=template&id=0858a6ef&scoped=true&"
import script from "./View-ajuda.vue?vue&type=script&lang=js&"
export * from "./View-ajuda.vue?vue&type=script&lang=js&"
import style0 from "./View-ajuda.vue?vue&type=style&index=0&id=0858a6ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0858a6ef",
  null
  
)

export default component.exports